'use strict';
import { TokenType } from "../Types";
export class HeaderHTML {
    constructor(token) {
        this.token = token;
    }
    getDept(token) {
        const depthMap = {
            [TokenType.HEADING_FIRST]: 1,
            [TokenType.HEADING_SECOND]: 2,
            [TokenType.HEADING_THIRD]: 3,
            [TokenType.HEADING_FOURTH]: 4,
            [TokenType.HEADING_FIFTH]: 5,
        };
        return depthMap[token.type] ?? 6;
    }
    render() {
        const dept = this.getDept(this.token);
        const headingText = this.token.value || '';
        const headingId = headingText
            .toLowerCase()
            .trim()
            .replace(/\s+/g, '-')
            .replace(/[^a-z0-9-]/g, '');
        return `<h${dept} id="${headingId}" class="md-heading md-h${dept}">${headingText}</h${dept}>`;
    }
}
